import React from 'react'
import Counter from '../../../../components/Counter'
import { CartItem } from '../../../cart/storage/cart.types'
import { SideContainer } from '../../../products/components/ProductCard'
import { CartItemCard } from '../../../products/components/ProductCard/CartItemCard'
import { CounterView } from '../../../products/components/ProductCard/ProductCardParent'
import { generateImageUrl } from '../../../../util/helpers'

export interface QuoteProductCardProps {
  item: CartItem
  onChangeQuantity?: (value: number, blur?: boolean) => void
  enableQuantity?: boolean
  enableRemove?: boolean
  handleOpenEditPriceModal?: () => void
  priceEditable?: boolean
  hideDownCount?: boolean
  onRemove?: () => void
}

export const QuoteProductCard: React.FC<QuoteProductCardProps> = ({
  item,
  onChangeQuantity,
  enableQuantity = true,
  enableRemove = true,
  handleOpenEditPriceModal,
  priceEditable = false,
  hideDownCount = false,
  onRemove,
}) => {
  const renderSideContainer = enableQuantity ? (
    <SideContainer>
      <CounterView>
        <Counter
          value={item.quantity}
          hideDownCount={hideDownCount}
          onChange={(value, blur) => {
            if (onChangeQuantity) {
              onChangeQuantity(value, blur)
            }
          }}
        />
      </CounterView>
    </SideContainer>
  ) : null

  return (
    <CartItemCard
      item={{ ...item, imageUrl: generateImageUrl(item.itemNumber) }}
      showImage
      onRemove={enableRemove ? onRemove : undefined}
      handleOpenEditPriceModal={handleOpenEditPriceModal}
      priceEditable={priceEditable}
      renderSideContainer={renderSideContainer}
      showUrgentDeliveryUnavailableMessage={false}
    />
  )
}
